import { ShiftsEmployeesPermissionFragment } from 'generated/resources/graphql'

export interface Props {
  create: boolean
  create_leave: boolean
  approve_leave: boolean
  delete_leave: boolean
}

export interface ShiftPermissionsPayload extends Props {}

class ShiftPermissions {
  create: boolean
  createLeave: boolean
  approveLeave: boolean
  deleteLeave: boolean

  constructor(props: Props) {
    this.create = props.create
    this.createLeave = props.create_leave
    this.approveLeave = props.approve_leave
    this.deleteLeave = props.delete_leave
  }

  /**
   * @deprecated Before using this method, consider using the `buildFromGraphQL` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  static buildFromRequest(props: ShiftPermissionsPayload): ShiftPermissions {
    return new ShiftPermissions({
      create: props.create,
      create_leave: props.create_leave,
      approve_leave: props.approve_leave,
      delete_leave: props.delete_leave,
    })
  }

  static buildFromGraphQL(fragment: ShiftsEmployeesPermissionFragment): ShiftPermissions {
    return new ShiftPermissions({
      create: fragment.permissions.create,
      create_leave: fragment.permissions.createLeave,
      approve_leave: fragment.permissions.approveLeave,
      delete_leave: fragment.permissions.deleteLeave,
    })
  }
}

export default ShiftPermissions
